export const priceFormatter = (number) => {
   let localNumber = number.toLocaleString('en-IN'); 
   return  localNumber;
}
